<template>
<div class="alarm-rule-container">
  <div class="device-data-area">
    <div class="alarm-data-area" ref="table1">
      <vxe-table :empty-text="showLang('com.data.no')" border resizable show-overflow show-header-overflow keep-source
          ref="chkTable" :key="dataRefresh" :data="list" height="auto" stripe
          :row-config="{isHover: true}" :checkbox-config="{checkField: 'checked',}" row-id="id">
        <vxe-column width="60" title="状态">
          <template #default="params">
            <span :style="{color: params.row.enable ? 'green' : 'red'}">{{ params.row.enable ? "启用":"停用" }}</span>
          </template>
        </vxe-column>
        <vxe-column field="name" title="名称"></vxe-column>
        <vxe-column field="appId" title="应用ID"></vxe-column>
        <vxe-column field="appSecret" title="密钥"></vxe-column>
        <vxe-column field="appToken" title="令牌"></vxe-column>
        <vxe-column field="message" title="消息"></vxe-column>
        <vxe-column field="tokenTime" title="请求时间"></vxe-column>
        <vxe-column width="180" title="操作" fixed="right">
          <template #header>
            <Button v-if="funCodes(9951)" size="small" type="primary" @click="handleAdd" style="margin-right: 5px">新增</Button>
            <Button v-if="funCodes(9950)" size="small" type="primary" @click="getList" style="margin-right: 5px">刷新</Button>
          </template>
          <template #default="params">
            <Button v-if="funCodes(9952)" size="small" :type="params.row.enable ? 'warning':'success'" @click="handleEnable(params)" style="margin-right: 5px">{{params.row.enable ? "停用":"启用"}}</Button>
            <Button v-if="funCodes(9952)" size="small" type="info" @click="handleEdit(params)" style="margin-right: 5px">编辑</Button>
            <Button v-if="funCodes(9953)" size="small" type="error" @click="handleDelete(params)" style="margin-right: 5px">删除</Button>
          </template>
        </vxe-column>
      </vxe-table>
    </div>
    <!-- <vxe-pager :layouts="pageLayouts" :current-page.sync="filter.index" :page-size.sync="filter.size" :total="total" :page-sizes='pageSizes' @page-change="handlePageChange"></vxe-pager> -->
    <ModalItemEdit v-model="showEditModal" :item="editItem" :connectTypes="connectTypes" @saved="itemSaved" />
  </div>
</div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import ModalItemEdit from './ModalItemEdit'
export default {
  name: 'ConfigLedIndex',
  components:{
    ModalItemEdit,
  },
  props: {
  },
  data () {
    return {
      list: [],
      total: 0,
      editItem: {isAdd: true, data: {}},
      showEditModal: false,
      filter: {
        groupId: 0,
        name: '',
        code: '',
        index: 1,
        size: 20
      },
      connectTypes: [],
      dataRefresh: 0,
    }
  },
  computed: {
    ...mapState('cmd', ['windowOnResize', 'cmds']),
    ...mapGetters('auth', ['funCodes', 'showLang']),
    ...mapState('common', ['pageLayouts', 'pageSizes']),
    ...mapState('group', ['groups', 'groupTreeSelectedNode']),
  },
  watch: {
  },
  mounted: function(){
    this.search();
  },
  destroyed: function(){
  },
  methods: {
    search: function(){
      this.filter.index = 1
      this.getList()
    },
    handlePageChange({ currentPage, pageSize }) {
      this.filter.index = currentPage
      this.filter.size = pageSize
      this.getList()
    },
    getCheckedItems: function(){//查询所有被选中的记录
      return this.$refs.chkTable.getCheckboxRecords();
    },
    handleAdd: function(){
      this.editItem = {isAdd: true, data: {}};
      this.showEditModal = true;
    },
    handleEdit: function(params){
      this.editItem = {isAdd: false, data: params.row};
      this.showEditModal = true;
    },
    itemSaved: function(){
      this.getList();
    },
    handleDelete: function(params){
      this.$Modal.confirm({
        title: "提示",
        content: `确定要删除[${params.row.name}]吗?`,
        onOk: async () => {
          this.$axios.post(`site/weixin/DeleteWXApp`, {appId: params.row.appId}).then(res => {
            if(res.code != 0){
              // this.$Message.error(res.data);
            }else{
              this.getList();
            }
          });
        }
      });
    },
    handleEnable: function(params){
      let name = params.row.enable ? '停用' : '启用';
      let enable = !params.row.enable;
      this.$Modal.confirm({
        title: "提示",
        content: `确定要${name}此微信应用吗?`,
        onOk: async () => {
          this.$axios.post(`site/weixin/EnableWXApp`, {appId: params.row.appId, enable}).then(res => {
            if(res.code != 0){
              // this.$Message.error(res.data);
            }else{
              this.getList();
            }
          });
        }
      });
    },
    getList: function(){
      this.$axios.post(`site/weixin/QueryWXApp`, {}).then(res => {
        if(res.code != 0){
          // this.$Message.error(res.data);
        }else{
          this.$set(this, 'list', res.data);
          this.dataRefresh++;
        }
      });
    },
  }
}
</script>
<style scoped>
.alarm-rule-container{
  height: 100%;
  display: flex;
  /* flex-direction: column;
  align-content: stretch; */
  /* padding: 10px; */
  /* padding-right: 40px; */
  /* border: solid 1px red; */
}
.config-tree-area{
  border: solid 1px #dcdee2;
  width: 300px !important;
  flex: none;
  border-radius: 6px;
}
.device-data-area {
  margin-left: 10px;
  border: solid 1px #dcdee2;
  width: 300px;
  flex: auto;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
}
.query-data-area {
  border-bottom: solid 1px #dcdee2;
  align-items: center;
  /* margin: 5px 0; */
  padding: 5px 0;
  height: 45px;
  flex: none;
}
.alarm-data-area{
  /* border: solid 1px red; */
  height: 100px;
  flex: auto;
  /* border: solid 1px #DCDEE2; */
  border-radius: 6px;
  /* padding-left: 10px; */
}
.station-alarm-tabs{
  height: 30px;
  flex: none;
  display: flex;
}
.station-alarm-tab{
  padding: 3px 8px;
  margin: 3px 3px 0 3px;
  border: solid 1px lightgray;
  border-radius: 5px 5px 0 0;
  cursor: pointer;
  background-color: white;
}
.tab-active{
  border: solid 1px rgb(135, 159, 224);
  background-color: rgb(135, 159, 224);
  color: white;
}
.station-alarm-tabcontent{
  height: 500px;
  flex: auto;
  /* border: solid 1px red; */
}
</style>